import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { apiUrl } from 'src/environments/environment';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  storage = null;
  accessToken = '';
  headers = {};
  constructor(private http: HttpClient) {
    this.storage = localStorage.getItem('at');

    if (this.storage) {
      const decode = atob(this.storage);
      this.accessToken = JSON.parse(decode);
    }

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }
  turnOnDb() {
    let body = {
      request_data: {
        type_action: 'turn_on',
      },
    };
    localStorage.clear();

    return this.http.post<any>(`${apiUrl.BASE_URL}/login`, body, this.headers);
  }

  login(loginData: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'login',
        data: {
          correo_usuario: loginData['correo_usuario'],
          clave_usuario: loginData['clave_usuario'],
        },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/login`, body, this.headers);
  }
  logout(id_usuario) {
    let body = {
      request_data: {
        type_action: 'logout',
        data: {
          id_usuario: id_usuario,
        },
      },
      headers: {
        Authorization: this.accessToken,
      },
    };
    localStorage.clear();

    return this.http.post<any>(`${apiUrl.BASE_URL}/login`, body, this.headers);
  }
}
